/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PatchedMainPageTagRequest
 */
export interface PatchedMainPageTagRequest {
  /**
   *
   * @type {string}
   * @memberof PatchedMainPageTagRequest
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof PatchedMainPageTagRequest
   */
  customId?: number | null
}

/**
 * Check if a given object implements the PatchedMainPageTagRequest interface.
 */
export function instanceOfPatchedMainPageTagRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PatchedMainPageTagRequestFromJSON(json: any): PatchedMainPageTagRequest {
  return PatchedMainPageTagRequestFromJSONTyped(json, false)
}

export function PatchedMainPageTagRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedMainPageTagRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    customId: !exists(json, 'customId') ? undefined : json['customId'],
  }
}

export function PatchedMainPageTagRequestToJSON(value?: PatchedMainPageTagRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    customId: value.customId,
  }
}
